"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfEnquirySourceStatItemDto = instanceOfEnquirySourceStatItemDto;
exports.EnquirySourceStatItemDtoFromJSON = EnquirySourceStatItemDtoFromJSON;
exports.EnquirySourceStatItemDtoFromJSONTyped = EnquirySourceStatItemDtoFromJSONTyped;
exports.EnquirySourceStatItemDtoToJSON = EnquirySourceStatItemDtoToJSON;
exports.EnquirySourceStatItemDtoToJSONTyped = EnquirySourceStatItemDtoToJSONTyped;
/**
 * Check if a given object implements the EnquirySourceStatItemDto interface.
 */
function instanceOfEnquirySourceStatItemDto(value) {
    if (!('source' in value) || value['source'] === undefined)
        return false;
    if (!('enquiry_count' in value) || value['enquiry_count'] === undefined)
        return false;
    return true;
}
function EnquirySourceStatItemDtoFromJSON(json) {
    return EnquirySourceStatItemDtoFromJSONTyped(json, false);
}
function EnquirySourceStatItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'source': json['source'],
        'enquiry_count': json['enquiry_count'],
    };
}
function EnquirySourceStatItemDtoToJSON(json) {
    return EnquirySourceStatItemDtoToJSONTyped(json, false);
}
function EnquirySourceStatItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'source': value['source'],
        'enquiry_count': value['enquiry_count'],
    };
}
